import { useEffect, Fragment, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { useOrganization } from "../../store/organization";
import { useOrderDetail } from "../../store/orderDetail";
import { PARTNERS, QUERY_PARAMS } from "../../utils/constants";
import Spinner from "../../components/Spinner";

// Sections
import { StickyHeader } from "./StickyHeader";
import { HeaderDescription } from "./HeaderDescription";
import { ProgramBreakdown } from "./ProgramBreakdown";
import { ImageGallery } from "./ImageGallery";
import { AboutPartner } from "./AboutPartner";
import { Reviews } from "./Reviews";
import { Specs } from "./Specs";
import { ZipEntryFlow } from "../../components/ZipEntryFlow";
import {usePartnerLanding} from "../../store/partnerLanding";
import useMediaQuery from "@mui/material/useMediaQuery";
import {StickyMobileBookButton} from "./StickyMobileBookButton";

const DESKTOP_CONTAINER_GRID = 5.1;

export function PartnerBuffer() {
  const isMobile = useMediaQuery("(max-width:600px)");

  const [searchParams] = useSearchParams();
  const params2 = useParams();

  const { getOrganization, organization } = useOrganization();
  const { updateFields } = useOrderDetail();
  const partnerLanding = usePartnerLanding();

  const [isZipModalOpen, setIsZipModalOpen] = useState(false);
 const client = searchParams.get(QUERY_PARAMS.CLIENT) || PARTNERS.JACK_RABBIT;
    const zip = searchParams.get(QUERY_PARAMS.ZIP);
    const entryFlow = searchParams.get(QUERY_PARAMS.ENTRY_FLOW);

  /** Save isMobile variable to store for use on other components */
  useEffect(() => {
    if (isMobile !== partnerLanding.isMobile) {
      partnerLanding.updateFields({ isMobile });
    }

    if (isMobile && !partnerLanding.isVisibleBookButton) {
      window.addEventListener("scroll", changeBookButtonVisibility);
    }
  }, [isMobile]);

  useEffect(() => {
   
    

    getOrganization(client);
    updateFields({ zip, client });

    window.analytics.track("Register Interest - JackRabbit Landing Page Visited", {
      url: window.location.href,
      referrer: document.referrer,
      searchParams: searchParams,
      params: params2,
      // category: params2.category,
      // group: params2.group,
      client: client,
      zip: zip,
      entryFlow: entryFlow,
    });

    if (entryFlow) {
      setIsZipModalOpen(true);
    }

  }, []);

  const changeBookButtonVisibility = () => {
    partnerLanding.updateFields({ isVisibleBookButton: true });
    window.removeEventListener("scroll", changeBookButtonVisibility);
  };

  const handleZipModalOpen = (button) => {
    window.analytics.track("Register Interest - Clicked Book Test Ride Button", {
      url: window.location.href,
      referrer: document.referrer,
      searchParams: searchParams,
      params: params2,
      button: button,
      // category: params2.category,
      // group: params2.group,
      client: client,
      zip: zip,
      entryFlow: entryFlow,
    });
    setIsZipModalOpen(true);
  };

  return (
    <Grid
      container={true}
      justifyContent="center"
      alignContent="center"
      sx={{
        backgroundColor: "#ccc",
      }}
    >

      {/** Initial loading */}
      <Spinner size={45} isLoading={organization.isLoading} className="tw-absolute tw-inset-y-1/2 tw-inset-y-1/2" />

      {organization.data?.landingDetails && (
        <Grid
          item={true}
          className="tw-min-h-screen"
          lg={DESKTOP_CONTAINER_GRID}
          sm={12}
          xs={12}
          mb={{ xs: "80px" }}
          sx={{
            backgroundColor: "#ffffff"
          }}
        >
        <StickyHeader
          lg={DESKTOP_CONTAINER_GRID}
          toggleZipModalOpen={()=> handleZipModalOpen("header")}
        />

        <HeaderDescription />

        <ProgramBreakdown toggleZipModalOpen={()=>handleZipModalOpen("breakdown")} />

        <ImageGallery />

        <AboutPartner toggleZipModalOpen={()=>handleZipModalOpen("about")} />

        <Reviews />

        <Specs />

        {isZipModalOpen && <ZipEntryFlow isZipModalOpen={isZipModalOpen} setIsZipModalOpen={setIsZipModalOpen} />}

        {isMobile && partnerLanding.isVisibleBookButton && <StickyMobileBookButton onClick={()=>handleZipModalOpen("sticky mobile button")} />}

        </Grid>
      )}
    </Grid>
  );
}
